/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function NewWindow(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M13.977 3.642a.91.91 0 0 1 0 1.82H5.54a.09.09 0 0 0-.09.09V18.46c0 .05.04.09.09.09h12.907c.05 0 .09-.04.09-.09v-8.43a.91.91 0 1 1 1.82 0v8.43a1.91 1.91 0 0 1-1.91 1.91H5.54a1.91 1.91 0 0 1-1.91-1.91V5.552a1.91 1.91 0 0 1 1.91-1.91zM21.47 1.53c.599 0 1 .4 1 1v4c0 .4-.201.8-.6.9-.101.1-.301.1-.4.1-.3 0-.5-.1-.701-.3l-.9-.9c-.1-.1-.3-.1-.4 0l-7.1 7.1c-.5.5-1.3.5-1.8 0s-.5-1.3 0-1.8l7.1-7.1c.1-.1.1-.3 0-.4l-.9-.9c-.2-.2-.3-.4-.3-.7 0-.6.4-1 1-1z"
  }));
}